import * as ng from 'angular';

class ActivationMailSentModalController implements ng.IController {

    static $inject: string[] = [
        '$scope'
    ];
    private close: any;

    constructor(
        private $scope: any
    ) {
        $scope.ok = () => {
            this.close();
        };
    }
}

export const ActivationMailSentModalComponent: ng.IComponentOptions = {
    template: require('./activation-mail-sent-modal.html'),
    controller: ActivationMailSentModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activation-mail-sent-modal/activation-mail-sent-modal.ts